import React from 'react'
import { Table } from 'semantic-ui-react'

export const OrderChargesTableHeader: React.FC = () => {
  return (
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell content="Tipo" />
        <Table.HeaderCell content="Vencimento" />
        <Table.HeaderCell content="Valor" />
        <Table.HeaderCell content="Pago" />
        <Table.HeaderCell />
      </Table.Row>
    </Table.Header>
  )
}
